import request from "./axios";

export const postFile = (url, params, headers) => {
    return request({
        url: url,
        method: "post",
        data: params,
        headers: {
            ...headers,
            'x-requested-with': 'XMLHttpRequest'
        }
    });
}
export const post = (url, params, headers) => {
    let data = [];
    if (params !== null && params !== undefined) {
        Object.keys(params).forEach(key => {
            data.push(encodeURIComponent(key) + "=" + encodeURIComponent(params[key]));
        });
    }
    const postHeaders = headers
        ? headers
        : {"Content-Type": "application/x-www-form-urlencoded"};
    return request({
        url: url,
        method: "post",
        data: data.join("&"),
        headers: {
            ...postHeaders,
            'x-requested-with': 'XMLHttpRequest'
        }
    });
};

export const simplePost = (url, params) => {
    return request({
        url: url,
        method: "post",
        data: params
    });
};

export const get = (url, params, headers) => {
    const getHeaders = headers
        ? headers
        : {"Content-Type": "application/x-www-form-urlencoded"};
    return request({
        url: url,
        method: "get",
        params: params,
        headers: {
            ...getHeaders,
            'x-requested-with': 'XMLHttpRequest'
        }
    });
};
